<script>
    import SingleContact from "./SingleContact.svelte";
    import { slide } from "svelte/transition";
    import { createEventDispatcher, onDestroy } from "svelte";

    export let day;
    export let index;
    export let openIndex;
    console.log(day);

    const dispatch = createEventDispatcher();
    function toggleAccordion() {
        dispatch("toggle", index);
    }

    let isSmallScreen = false;
    let isMediumScreen = false;
    let isLargeScreen = false;

    function handleResize() {
        const smallScreenQuery = window.matchMedia("(max-width: 767px)");
        const mediumScreenQuery = window.matchMedia("(min-width: 768px) and (max-width: 1024px)");
        const largeScreenQuery = window.matchMedia("(min-width: 1025px)");

        isSmallScreen = smallScreenQuery.matches;
        isMediumScreen = mediumScreenQuery.matches;
        isLargeScreen = largeScreenQuery.matches;
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    onDestroy(() => {
        window.removeEventListener("resize", handleResize);
    });
</script>

<div data-type="day" class="px-8 my-16 min-w-[320px]">
    <button
        type="button"
        on:click={() => toggleAccordion(index)}
        class="
            appearance-none
            bg-custom-gradient-n 
            active:bg-custom-gradient-a 
            hover:bg-custom-gradient-h 
            focus:bg-custom-gradient-f 
            px-4 
            py-2 
            focus:outline-none 
            w-full"
    >
        <h2 class="
            font-bold
            flex
            justify-between"
        >
            <div>
                {day.date}
            </div>
            <div>
                {openIndex === index ? '▼' : '▲'}
            </div>
        </h2>
    </button>
    {#each day.persons as contact}
        {#if openIndex === index}
            <div
                class="bg-gray-700"
                in:slide={{ duration: 300 }}
                out:slide={{ duration: 300 }}
            >
                <SingleContact
                    {contact}
                    {isSmallScreen}
                    {isMediumScreen}
                    {isLargeScreen}
                />
            </div>
        {/if}
    {/each}
</div>
